import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";
import type { ConfigOf } from "../../../install/types.ts";
import { DatabaseHosting } from "../db/components.ts";

export const PostgresComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Access management",
    description: "Manage access to a PostgreSQL database.",
    type: "string",
    maturity: "preview",
    schema: {
      hostname: Element({
        label: "Database host",
        description: "The IP address of the database",
        type: "generated",
      }),
      port: Element({
        label: "Database port",
        description: "The database port (defaults to 3306)",
        type: "string",
      }),
      defaultDb: Element({
        label: "Default database",
        description: "Access requests will default to this database (optional)",
        type: "string",
      }),
      hosting: DatabaseHosting,
    },
  }),
  "row-security-policy": ItemComponent({
    label: "Row security policy",
    description: "Constrain access to data with row-level policy",
    type: "string",
    maturity: "preview",
    schema: {
      instance: Element({
        label: "PostgreSQL instance",
        description: "The PostgreSQL instance this policy applies to",
        type: "dynamic",
      }),
      policy: Element({
        label: "Row security policy",
        type: "hidden",
      }),
    },
  }),
  "session-audit": ItemComponent({
    label: "Session audit",
    description: "Audit sessions on a PostgreSQL database.",
    type: "dynamic",
    maturity: "preview",
    schema: {
      functionCaller: Element({
        label: "Function caller to invoke",
        description:
          "The function caller to invoke to retrieve session audit logs.",
        type: "dynamic",
      }),
    },
  }),
});

export type PostgresIntegration = ConfigOf<typeof PostgresComponents>;

export type PostgresIamWriteConfig = PostgresIntegration["iam-write"][string];
